import { observer, useLocalStore } from 'mobx-react';
import * as React from 'react';
import { OcDataview } from '../../comps/OcDataview';
import { OcDataviewFiltering } from '../../comps/OcDataviewFiltering';
import { PleaseWait } from '../../comps/PleaseWait';
import { Submenu } from '../../comps/Submenu';
import { useNoSubmenu } from '../../mainpanel/useSubmenu';
import { mg } from '../../mg/mg';
import { mgColumnFactory, MgColumnist } from '../../mg/table/MgColumn';
import { MgEntityEditDialog } from '../../mg/table/MgEntityEditDialog';
import { toasterSvc } from '../../services/ToasterSvc';
import { DataviewStore } from '../../stores/DataviewStore';
import { useOmnistore } from '../../stores/Omnistore';

const columnist = mgColumnFactory.createColumnist([
	'/id',
	'/creationTimestamp :datetime',
	'/timestamp :datetime',
	'customerNo',
	'zipcode',
	'branch.name',
	'branch.owner.email',
	'supplier.name',
	'supplier.kind',

	null,
	'isOrderable :bool',
	'isReady :bool',
	'isDeleted :bool',
	'isBlocked :bool',
	// '_stat_lastOrderTimestamp_datetime =lastOrderTimestamp w150p0 ro', //TODO
	// '_stat_previousMonthOrderCount w70p0 ro',
	// '_stat_currentMonthOrderCount w70p0 ro',
	// '_stat_orderCount w70p0 ro',
	// '_stat_prevalentDayOfWeek *DayOfWeekExt +transl w70p0 ro',
	// 'size =Items w100p0 link=items ro', //TODO
]);

const dataviewStore = DataviewStore.create({
	id: 'AdmTemplatePage',
	orgColumns: columnist.descriptors,
	filtering: [{columns: ['isDeleted'], type: 'BOOLEAN'}, {columns: ['customerNo']}, {columns: ['zipcode']}],
});
dataviewStore.hideAllButListed('customerNo', 'zipcode', 'isDeleted');

interface IAdmTemplateDialogProps {
	columnist: MgColumnist
	entity?: object
	onClose() : void
}

const AdmTemplateDialog = observer(function AdmTemplateDialog(props: IAdmTemplateDialogProps) {
	const {columnist, entity, onClose} = props;
	const editable = useLocalStore(() => columnist.newEntity(entity)) as Record<string, any>;
	const omnistore = useOmnistore();
	const multirepo = omnistore.multirepo;
	function finish(entity: Record<string, any>) : void {
		if (!entity) return onClose();
		console.log(mg.stringify(entity));
		omnistore.communicator.doPost('UpdateTemplate', entity)
			.then(toasterSvc.handleResponse('saved'))
			.then(r => {
				if (r.outputObject) {
					multirepo.templateRepo.fetch('DIRECT');
					onClose();
				}
			});
	}
	function showItems() {
		const router = omnistore.locationStore;
		router.setPage('AdmTemplateItemPage');
		router.setBranchId(editable.branchId || 0);
		router.setSupplierId(editable.supplierId || 0);
	}
	return <MgEntityEditDialog
		columnist={columnist}
		extras={columnist.newExtras(editable, {})}
		entity={editable}
		baseName="AdmTemplateDialog"
		finish={finish}
	>
		{[
			{name: 'items', onClick: showItems},
		]}
	</MgEntityEditDialog>;
});

export const AdmTemplatePage = observer(function AdmTemplatePage() {
	const omnistore = useOmnistore();
	columnist.setExternalGet(omnistore.multirepo.externalGet);
	const repo = omnistore.multirepo.templateRepo;
	React.useEffect(() => {
		repo.fetch();
		omnistore.multirepo.admSupplierRepo.fetch();
		omnistore.multirepo.branchRepo.fetch();
		omnistore.multirepo.userRepo.fetch();
	}, []);
	useNoSubmenu();
	const onDialogClose = () => dataviewStore.rowClick(0);
	const selectedEntity = repo.byId(dataviewStore.selectedEntityId);
	return !repo.etag ? <PleaseWait/> : <>
		<Submenu>
			<OcDataviewFiltering state={dataviewStore} repo={repo}/>
			---
		</Submenu>
		<OcDataview state={dataviewStore} repo={repo}/>
		{!selectedEntity ? null : <AdmTemplateDialog entity={selectedEntity} columnist={columnist} onClose={onDialogClose}/>}
	</>;
});
